const progLanguages = [
    {id: 0, name: '.Net'},
    {id: 1, name: 'Java'},
    {id: 2, name: 'PHP'},
]

export default progLanguages